import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import CaregiverContactInfoDescription from '../../../components/FormDescriptions/CaregiverContactInfoDescription';
import { emailUI, phoneUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['primary-info-title--contact'];
const INPUT_LABEL = content['primary-input-label'];

const { email, phone } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(
      TITLE_TEXT,
      CaregiverContactInfoDescription({ label: INPUT_LABEL }),
    ),
    primaryPrimaryPhoneNumber: phoneUI(`${INPUT_LABEL} primary`),
    primaryAlternativePhoneNumber: phoneUI(`${INPUT_LABEL} alternative`),
    primaryEmail: emailUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['primaryPrimaryPhoneNumber'],
    properties: {
      primaryPrimaryPhoneNumber: phone,
      primaryAlternativePhoneNumber: phone,
      primaryEmail: email,
    },
  },
};
